<h2 mat-dialog-title>StopSale miast — {{ data.termName }}</h2>

<mat-dialog-content>
	@if (isLoading()) {
		<div class="loading-wrapper">
			<mat-spinner diameter="36"></mat-spinner>
		</div>
	} @else if (rows().length === 0) {
		<p class="empty-state">Brak miast w transporcie wyjazdu i powrotu dla tego terminu.</p>
	} @else {
		<table mat-table [dataSource]="rows()" class="w-100">
			<ng-container matColumnDef="side">
				<th mat-header-cell *matHeaderCellDef>Strona</th>
				<td mat-cell *matCellDef="let row">{{ sideLabel(row.side) }}</td>
			</ng-container>
			<ng-container matColumnDef="city">
				<th mat-header-cell *matHeaderCellDef>Miasto</th>
				<td mat-cell *matCellDef="let row">{{ row.stopName }}</td>
			</ng-container>
			<ng-container matColumnDef="time">
				<th mat-header-cell *matHeaderCellDef>Czas</th>
				<td mat-cell *matCellDef="let row">
					@if (row.timeDeparture) {
						{{ row.timeDeparture | date: 'dd.MM.yyyy HH:mm' }}
					} @else {
						—
					}
				</td>
			</ng-container>
			<ng-container matColumnDef="stopSale">
				<th mat-header-cell *matHeaderCellDef>StopSale</th>
				<td mat-cell *matCellDef="let row" [ngClass]="{ 'text-danger fw-bold': row.stopSale }">
					<mat-slide-toggle
						[checked]="row.stopSale"
						[disabled]="isPending(row.id)"
						(change)="onToggle(row, $event)"
						aria-label="Toggle StopSale dla miasta"
					></mat-slide-toggle>
				</td>
			</ng-container>
			<tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
			<tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
		</table>
	}
</mat-dialog-content>

<mat-dialog-actions align="end">
	<span class="me-auto blocked-summary">Zablokowanych miast: {{ blockedCount() }}</span>
	<button mat-button (click)="close()">Zamknij</button>
</mat-dialog-actions>
